"use strict"

class Clients {
    constructor() {
        this.isMobile = false;
        this.isDesktop = false;
        this.breakpoint = 790;
        this.noResize = true;
        this.map = document.querySelector('.sl-Map');
        this.clients = document.querySelector('.sl-Clients');
        this.fullpage = document.querySelector('#fullpage');;
        if (this.clients) {
            this.leftArrow = this.clients.querySelector('.clients-arrow-left:not(.clients-arrow-left-mob)');
            this.rightArrow = this.clients.querySelector('.clients-arrow-right:not(.clients-arrow-right-mob)');
            this.leftArrowMob = this.clients.querySelector('.clients-arrow-left-mob');
            this.rightArrowMob = this.clients.querySelector('.clients-arrow-right-mob');
        }
    }
    renderMethodOnLoad() {
        window.innerWidth < this.breakpoint ? this.mobileMethod() : this.desktopMethod()
        window.innerWidth < this.breakpoint ? this.isDesktop = true : this.isMobile = true;
    }
    renderMethodOnResize() {
        window.onresize = () => {
            if (window.innerWidth < this.breakpoint) {
                this.isDesktop = true;
                if (this.isMobile) this.mobileMethod()
                this.isMobile = false;
            } else {
                this.isMobile = true;
                if (this.isDesktop) this.desktopMethod()
                this.isDesktop = false;
            }
        };
    }
    triggerSlickRendering() {
        // set a method every 100ms
        const triggerSlick = setInterval(() => {
            // when slick is rendered
            if (this.clients.querySelector('.slick-track')) {
                setTimeout(() => {
                    const clientSlicks = document.querySelectorAll('.clients-slick .slick-slider ul');
                    [...clientSlicks].map(x => {
                        // set style height according to client height
                        x.style.height = `${x.clientHeight}px`;
                        const childs = x.querySelectorAll('li');
                        // set child style height according to client height / 5
                        [...childs].map(y => y.style.height = `${x.clientHeight / 5}px`)
                    })
                }, 500);
                // then, clear the interval
                setTimeout(() => clearInterval(triggerSlick), 1000);
            }
        }, 100);
    }
    mobileMethod() {
        // remove child node 
        this.map.removeChild(this.clients);
        this.clients.classList.add('fullpage-section');
        // appendchild to fullpage rendering
        this.fullpage.insertBefore(this.clients, this.fullpage.childNodes[9]);
        // generate carousel mon mobile
        $('.sl-Clients .wrapper').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: this.leftArrowMob,
            nextArrow: this.rightArrowMob
        })
        this.triggerSlickRendering();
    }
    desktopMethod() {
        $('.sl-Clients .wrapper').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: this.leftArrow,
            nextArrow: this.rightArrow
        })
    }
    setFullPage() {
        if (this.clients) {
            this.renderMethodOnLoad()
            if (this.noResize) this.renderMethodOnResize()
        }
    }
}

export default Clients


// WEBPACK FOOTER //
// ./src/scripts/components/Clients.js